<template>
  <div class="selectDropdown">
    <div class="select" @click.stop="toggle">
      <input type="text"
          :value="computedSelectedValue"
          required :class="{error : error, standardInput : type}">
      <div class="select__title subhead" :class="{standardLabel : type}">{{label}}</div>
      <div class="select__icon" :class="{ standardIcon : type }">
        <i v-if="isShown" class="icon-chevronup"></i>
        <i v-else class="icon-chevrondown"></i>
      </div>
    </div>
    <div class="popup" v-if="isShown">
      <div class="popup__loading" v-if="loading">
        <adx-loading/>
      </div>
      <div v-else>
        <div class="popup__input" :class="{'popup__input--focus':isFocus}" @click="setFocus">
          <span class="popup__input__icon__left"><i class="icon-search"></i></span>
          <input ref="input" type="text" class="popup__input__dropdown" :class="size"
            @focus="onFocus" @blur="isFocus = false" @keyup="searchData" placeholder="Search" >
          <span v-if="search != ''" @click.stop="clear" @mouseover="hasFocused" class="popup__input__icon__right"><i class="icon-clear"></i></span>
        </div>
        <div v-if="insertAddNew" class="popup__background">
          <div class="item addNew"
            @click.stop="emitAddNew">
            <span class=""></span>
            <span class="subhead text">Add New</span>
          </div>
        </div>
        <div class="popup__background"
          v-for="option in options" :key="option.id">
          <div class="item"
            @click.stop="onItemClick(option)">
            <span :class="{ 'icon-check': isChecked(option) }"></span>
            <span class="subhead text"
              >{{ option.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <p v-if="validationError" class="msg-error small-font">{{message || error}}</p>
  </div>
</template>

<script>
import Vue from 'vue'
import * as validationLib from '@/lib/validation/'
import LoadingPrimary from '@/components/Loading/Primary'

const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-select-dropdown',
  components: {
    'adx-loading': LoadingPrimary,
  },
  props: {
    loading: {
      required: false,
      default: false,
    },
    optionsParam: {
      required: true
    },
    value: {
      required: false
    },
    error: {
      required: false
    },
    label: {
      required: false
    },
    validation: {
      required: false
    },
    type: {
      required: false
    },
    needFocus: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    needEventEmitter: {
      required: false,
      default: false
    },
    itemId: {
      required: false
    },
    size: {
      required: false
    },
    errorLabel: {
      required: false
    },
    insertAddNew: {
      required: false
    }
  },
  data() {
    return {
      options: [],
      defaultOptions: [],
      search: '',
      isFocus: false,
      isFocused: false,
      valid: undefined,
      message: undefined,
      isShown: false,
      selectedText: '',
      selectedItem: undefined
    }
  },
  beforeMount() {
    
  },
  mounted() {
    this.options = this.optionsParam
    if (this.value) {
      const selectedOption = this.options.filter(x => x.value === this.value).pop()
      this.$data.selectedItem = selectedOption
      this.selectedText = selectedOption.value
    }
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
    this.$nextTick(function () {
      Vue.$broker.$on('app-click', this.onAppClick.bind(this))
    })
    this.defaultOptions = this.options
  },
  methods: {
    hasFocused() {
      if (this.isFocus) {
        this.isFocused = true
      } else {
        this.isFocused = false
      }
    },
    clear() {
      this.$refs.input.value = ''
      this.search = ''
      this.searchData()
      if (this.isFocused) this.$refs.input.focus()
    },
    searchData(ev) {
      this.search = this.$refs.input.value
      let tempOptions = []
      this.defaultOptions
        .map(element => {
          if (element.label.toLowerCase().startsWith(this.search.toLowerCase())) {
            tempOptions.push(element)
          }
        })
      this.options = tempOptions
    },
    toggle() {
      this.isShown = !this.isShown
    },
    onItemClick(item) {
      this.$data.selectedItem = item
      this.$data.selectedText = item.value
      this.$data.isShown = false
      const params = {
        item: item,
        id: this.itemId
      }
      this.$emit(`selected`, params)
    },
    isChecked(item) {
      return this.$data.selectedItem === item
    },
    onAppClick(sender) {
      if (this.isFocus) return
      if (sender === this) return
      this.$data.isShown = false
    },
    validateInput(value) {
      if (!value) value = this.value
      if (this.validation) {
        let usedLabel = null
        if (this.errorLabel) {
          usedLabel = this.errorLabel
        } else {
          usedLabel = this.label
        }
        const { valid, message } = validate(this.validation, value, usedLabel)
        if(valid) {
          if (this.needEventEmitter) this.$emit(`selectedValue`, value)
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        if (this.needEventEmitter) this.$emit(`selectedValue`, value)
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    },
    setFocus() {
      this.onFocus()
      this.$refs.input.focus()
    },
    onFocus() {
      this.isFocus = true
    },
    emitAddNew() {
      this.$emit(`addNew`)
      this.isShown = false
    }
  },
  watch: {
    selectedText() {
      this.validateInput(this.selectedText)
    },
    value: function () {
      if (this.value == '') {
        this.validateInput(this.selectedText)
      } else {
        this.selectedText  = this.value 
      }
    },
    optionsParam(){
      this.options = this.optionsParam
    },
  },
  computed: {
    computedSelectedValue: function () {
      const selectedItem = this.options.filter(x => x.value === this.selectedText).pop()
      if (selectedItem) {
        return selectedItem.label
      }
      return this.selectedText
    },
    validationError: function () {
      if (this.error) {
        return this.error
      }
      return this.valid === undefined ? false : !this.valid
    },
    filteredData () {
      var filterList = []
      this.list.map((data) => {
        var locations = []
        data.locations.map((value) => {
          if (value.location.toLowerCase().startsWith(this.search.toLowerCase())) {
            locations.push(value)
          }
        })
        var filtered = {"id":data.id, "title": data.title}
        filtered.locations = locations
        filterList.push(filtered)
      })
      if (filterList.length < 0) {
        this.selected = null
      }
      return filterList
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>